import { useMutation } from '@tanstack/react-query';
import { ClinicProduct } from '../types';
import { createClinicProducts } from '../requests';

type CreateClinicProduct = (clinicMasterProductId: string, data: ClinicProduct[]) => Promise<ClinicProduct>;

interface UseCreateClinicProductsReturn {
  createClinicProducts: CreateClinicProduct;
  isLoading: boolean;
}

export const useCreateClinicProducts = (): UseCreateClinicProductsReturn => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ([clinicMasterProductId, clinicProducts]: [string, ClinicProduct[]]) =>
      createClinicProducts(clinicMasterProductId, clinicProducts)
  });

  const createClinicProductsCallback = async (clinicMasterProductId: string, clinicProducts: ClinicProduct[]) => {
    const response = await mutateAsync([clinicMasterProductId, clinicProducts]);
    return response.data.data;
  };

  return {
    createClinicProducts: createClinicProductsCallback,
    isLoading
  };
};
